import {
  UPDATE_DOCUMENT,
  RESET_DOCUMENT,
  DELETE_DOCUMENT,
  GET_DOCUMENTS,
  EDIT_DOCUMENT,
  RESET_DOCUMENT_CHANGES,
  SET_SELECTED_TEXT,
  GET_AI_TEMPLATES,
  TOGGLE_INPUT_FORM,
  GENERATE_RESULTS,
  UPDATE_PROMPT,
  TOGGLE_LOADING_STATE,
  GET_AI_TEMPLATES_LIST,
  RESET_AI_TEMPLATES_LIST,
  AI_TEMPLATE_GET_ADDED,
} from "../_actions/types";

import { findIndex } from "lodash";

const initialState = {
  payload: [],
  data: {},
  changes: [],
  loaded: false,
  selectedText: "",
  aiTemplates: [],
  isInputFormCollapsed: false,
  generatingResults: false,
  isLoading: false,
  page: 1,
  templateList: [],
  pageTemplate: 1
};

export default function (state = initialState, action) {
  switch (action.type) {
    case RESET_DOCUMENT:
      return initialState;
    case GET_DOCUMENTS:
      let payload =
        action.payload.next !== null
          ? state.payload.concat(action.payload.results)
          : action.payload.results;
      return {
        ...state,
        payload: payload,
      };
    case UPDATE_DOCUMENT:
      return {
        ...state,
        data: action.payload,
        loaded: true,
      };
    case DELETE_DOCUMENT:
      return {
        ...state,
        payload: state.payload.filter((doc) => {
          const resultId = doc.content_id || doc.id;

          return resultId !== action.payload;
        }),
      };
    case EDIT_DOCUMENT:
      return {
        ...state,
        changes: [...state.changes, action.payload],
      };
    case RESET_DOCUMENT_CHANGES:
      return {
        ...state,
        changes: [],
      };
    case SET_SELECTED_TEXT:
      return {
        ...state,
        selectedText: action.payload,
      };
    case GET_AI_TEMPLATES_LIST:
      return {
        ...state,
        templateList: action.previous
          ? [...state.templateList, ...action.payload]
          : action.payload,
        pageTemplate: action.loadMore ? state.pageTemplate + 1 : state.pageTemplate,
        loadMore: action.loadMore,
    };
    case RESET_AI_TEMPLATES_LIST:
      return {
        ...state,
        templateList: [],
        pageTemplate: 1,
        loadMore: false,
      }
    case AI_TEMPLATE_GET_ADDED:
      let existTemplates = [];
      const newTemp = action.payload;
        newTemp.forEach((ele) => {
        const fontIndex = findIndex(existTemplates, ["id", ele.id]);
        if (fontIndex > -1) {
          existTemplates[fontIndex] = ele;
        } else {
          existTemplates.push(ele);
        }
      });
      return { ...state, templateList: existTemplates };
    case GET_AI_TEMPLATES:
      return {
        ...state,
        aiTemplates: action.payload,
        page: action.loadMore ? state.page + 1 : state.page,
        loadMore: action.loadMore,
      };
    case TOGGLE_INPUT_FORM:
      return {
        ...state,
        isInputFormCollapsed: action.payload,
      };
    case GENERATE_RESULTS:
      return {
        ...state,
        generatingResults: action.payload,
      };
    case UPDATE_PROMPT:
      return {
        ...state,
        data: {
          ...state.data,
          prompt: action.payload,
          payload: {
            ...state.data.payload,
            title: "",
            description: "",
            keywords: [],
          },
        },
      };
    case TOGGLE_LOADING_STATE:
      return {
        ...state,
        isLoading: action.payload,
      };
    default:
      return state;
  }
}
